// extracted by mini-css-extract-plugin
export default {"wrap":"referencesUserSubordinationArchive_wrap__BZkfv"};